import React from 'react';
import Privacy from '../components/Terms-Policy-Refund/Privacy';
import CenteredTitleSection from '../components/Terms-Policy-Refund/CenteredTitleSection';

const Terms = () => {
  return (
    <>
    <CenteredTitleSection
        title="Montessori Teacher Training"
        subtitle="Effective Date: 01/01/2025"
      />
      <Privacy />
    </>
  );
};

export default Terms;
